
import React from 'react';
import PageHeader from '../components/PageHeader';
import { Helmet } from 'react-helmet-async';

const TermsOfUse = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Use | LovaBuild</title>
        <meta name="description" content="Terms of use for LovaBuild services" />
      </Helmet>
      
      <PageHeader title="Terms of Use" />
      
      <div className="container mx-auto px-6 py-12">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <p className="text-lg text-luxury-600 mb-6">Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
          
          <h2 className="text-2xl font-display font-bold mb-4">1. Agreement to Terms</h2>
          <p>
            By accessing or using the LovaBuild website and services, you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our services.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">2. Description of Services</h2>
          <p>
            LovaBuild provides web development, design, and related digital services to clients. Our services include but are not limited to website development, application design, and digital consulting.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">3. User Accounts</h2>
          <p>
            When you create an account with us, you must provide accurate and complete information. You are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">4. Payment Terms</h2>
          <p>
            Payment terms will be as agreed upon in individual client contracts or as specified during the checkout process for specific services. All payments are non-refundable unless otherwise stated in writing.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">5. Intellectual Property</h2>
          <p>
            The content, features, and functionality of the LovaBuild website are owned by LovaBuild and are protected by copyright, trademark, and other intellectual property laws.
          </p>
          <p className="mt-2">
            Upon full payment for services, clients receive ownership rights to the deliverables as specified in their individual contracts.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">6. Limitation of Liability</h2>
          <p>
            In no event shall LovaBuild be liable for any indirect, consequential, exemplary, incidental, special, or punitive damages, including lost profit, even if LovaBuild has been advised of the possibility of such damages.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">7. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless LovaBuild from and against any claims, liabilities, damages, losses, and expenses arising out of or in any way connected with your access to or use of the services.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">8. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which LovaBuild is registered, without regard to its conflict of law provisions.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">9. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify users of any changes by updating the "Last Updated" date of these Terms.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">10. Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          <p className="mt-2">
            <strong>Email:</strong> terms@lovabuild.com
          </p>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
